
import { Routes } from "@angular/router";
import { DatabaseMigrationsComponent } from "projects/admin/src/lib/database-migrations/database-migrations.component";
//import { ManagePlatformGroupRolesComponent } from "projects/admin/src/lib/manage-platform-group-roles/manage-platform-group-roles.component";
import { EditProjectComponent } from "projects/admin/src/lib/manage-projects/edit-project/edit-project.component";
import { ManageProjectsComponent } from "projects/admin/src/lib/manage-projects/manage-projects.component";
import { EditTenantComponent } from "projects/admin/src/lib/manage-tenants/edit-tenant/edit-tenant.component";
import { ManageTenantsComponent } from "projects/admin/src/lib/manage-tenants/manage-tenants.component";
import { EditUserProfileComponent } from "projects/admin/src/lib/user-management/edit-user-profile/edit-user-profile.component";
import { UserManagementComponent } from "projects/admin/src/lib/user-management/user-management.component";
import { ProjectResolverService } from "projects/shared/src/lib/services/project-resolver.service";
import { TenantResolverService } from "projects/shared/src/lib/services/tenant-resolver.service";
import { UserResolverService } from "projects/shared/src/lib/services/user-resolver.service";
import { ProjectListComponent } from "projects/user/src/lib/project-list/project-list.component";
import { AppSettingsComponent } from "./app-settings/app-settings.component";
import { SquirrelDashboardComponent } from "./squirrel-dashboard/squirrel-dashboard.component";
import { UserChangePasswordComponent } from "./user-change-password/user-change-password.component";
import { UserProfileComponent } from "./user-profile/user-profile.component";
import { RoutingGuardTenant } from "projects/shared/src/lib/guards/routingGuardTenant";
import { SelectTenantComponent } from "projects/admin/src/lib/manage-tenants/select-tenant/select-tenant.component";
import { SelectTenantDialogComponent } from "projects/admin/src/lib/manage-tenants/select-tenant-dialog/select-tenant-dialog.component";
import { TenantGrouprolesComponent } from "projects/admin/src/lib/manage-tenants/edit-tenant/tenant-grouproles/tenant-grouproles.component";
import { CheckUserloginComponent } from "projects/admin/src/lib/user-management/check-userlogin/check-userlogin.component";
import { DemouserManagementComponent } from "projects/admin/src/lib/demouser-management/demouser-management/demouser-management.component";
import { UserprofileResolverService } from "projects/shared/src/lib/services/userprofile-resolver.service";
import { UserShowProfileComponent } from "projects/admin/src/lib/user-management/user-show-profile/user-show-profile.component";
import { ManageApitokensComponent } from "projects/admin/src/lib/manage-apitokens/manage-apitokens.component";
import { ManageAuditComponent } from "projects/admin/src/lib/manage-audit/manage-audit.component";
import { DatabaseUpdatesComponent } from "projects/admin/src/lib/database-updates/database-updates.component";
import { ManageFilesComponent } from "projects/admin/src/lib/manage-files/manage-files.component";
import { ProjectRoleTemplatesComponent } from "projects/admin/src/lib/manage-projects/project-role-templates/project-role-templates.component";

export const SquirrelLayoutRouts: Routes = [

    { path: 'check-userlogin', component: CheckUserloginComponent },
    { path: 'select-tenant', component: SelectTenantComponent },
    // { path: ':tenantId/dashboard', component: SquirrelDashboardComponent },
    { path: ':tenantId/all-projects', component: ProjectListComponent, canActivate: [RoutingGuardTenant]  },
    { path: ':tenantId/manage-apitokens', component: ManageApitokensComponent },
    { path: ':tenantId/manage-audit', component: ManageAuditComponent },
    { path: ':tenantId/manage-files', component: ManageFilesComponent },
    { path: ':tenantId/manage-projects', component: ManageProjectsComponent },
    { path: ':tenantId/project-role-templates', component: ProjectRoleTemplatesComponent },
    {
        path: ':tenantId/manage-projects/:id',
        component: EditProjectComponent,
        resolve: { resolvedData: ProjectResolverService }
    },
    { path: ':tenantId/manage-users', component: UserManagementComponent },
    {
        path: ':tenantId/manage-users/:id',
        component: EditUserProfileComponent,
        resolve: { resolvedData: UserResolverService }
    },
    { path: ':tenantId/manage-demousers', component: DemouserManagementComponent },
    { path: ':tenantId/manage-tenants', component: ManageTenantsComponent },
    {
        path: ':tenantId/manage-tenants/:id',
        component: EditTenantComponent,
        resolve: { resolvedData: TenantResolverService }
    },
    // { path: ':tenantId/tenant-grouproles', component: TenantGrouprolesComponent },
    { path: ':tenantId/tenant-groups', component: TenantGrouprolesComponent },
    //{ path: ':tenantId/manage-platform-grouproles', component: ManagePlatformGroupRolesComponent },
    { path: ':tenantId/database-migrations', component: DatabaseMigrationsComponent },
    { path: ':tenantId/database-updates', component: DatabaseUpdatesComponent },
    { path: 'user-profile', component: UserProfileComponent },
    {
        path: 'user-profile/:id',
        component: UserProfileComponent ,   resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'user-show-profile', component: UserShowProfileComponent },
    {
        path: 'user-show-profile/:id',
        component: UserShowProfileComponent ,   resolve: { resolvedData: UserprofileResolverService }
    },
    { path: 'settings', component: AppSettingsComponent },
    { path: 'user-change-password', component: UserChangePasswordComponent },

];
